const getters = {
  errorLogs: state => state.errorLog.logs
}

export default getters



// WEBPACK FOOTER //
// ./src/data/store/getters.js